var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ref, update, get, onValue } from 'firebase/database';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { database } from '../../config/firebaseConfig';
import mixpanel from '../../config/mixpanelConfig';
import axios from 'axios';
import { idToken } from '.';
import { _refreshUserToken } from '.';
import { displayToast } from '../../components/Toast';
// ----------------------------------------------
// Action creators
// ----------------------------------------------
export var createNewWorkspace = createAsyncThunk('workspace/create', function (_a, _b) {
    var name = _a.name;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var user, teamPlan, plan, newWorkspace;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    user = getState().user;
                    teamPlan = sessionStorage.getItem('team-plan') === 'true';
                    plan = teamPlan ? 'team' : 'free';
                    sessionStorage.removeItem('team-plan');
                    return [4 /*yield*/, _createWorkspace(name, user)];
                case 1:
                    newWorkspace = _c.sent();
                    newWorkspace && mixpanel.track('create workspace');
                    return [2 /*return*/, newWorkspace];
            }
        });
    });
});
export var _fetchWorkspace = function (workspaceId) {
    return new Promise(function (resolve, reject) {
        get(ref(database, "workspaces/".concat(workspaceId)))
            .then(function (snapshot) {
            var workspace = snapshot.val();
            resolve(workspace);
        })
            .catch(function (err) {
            console.log(err);
            reject();
        });
    });
};
export var unsubscribeWorkspaceListener = function () { };
/**
 * When called, this action creator fetches the Workspace from Firebase
 * but it's also responsible to update the Redux state if any change occurs
 * (e.g. another user makes a change to the Workspace).
 * @param workspaceId The ID of the Workspace to load
 */
export var loadWorkspaceAndListenForEvents = function (workspaceId) {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch({ type: 'workspace/load/pending' });
            unsubscribeWorkspaceListener();
            unsubscribeWorkspaceListener = onValue(ref(database, "workspaces/".concat(workspaceId)), function (snapshot) {
                var workspace = snapshot.val();
                dispatch({ type: 'workspace/load/fulfilled', payload: workspace });
                resolve(workspace);
            }, function (err) {
                console.log(err);
                dispatch({ type: 'workspace/load/reject' });
                reject();
            });
        });
    };
};
export var inviteUserToWorkspace = createAsyncThunk('workspace/user/invite', function (_a, _b) {
    var email = _a.email, permission = _a.permission;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId, userId, emailAsKey;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    workspaceId = getState().workspace.id;
                    userId = getState().user.id;
                    emailAsKey = email.replace(/\./g, ',');
                    return [4 /*yield*/, _inviteUserToWorkspace({
                            email: email,
                            workspaceId: workspaceId,
                            permission: permission,
                            authToken: idToken,
                        })];
                case 1:
                    _c.sent();
                    mixpanel.track('invite user', { permission: permission });
                    return [2 /*return*/, { email: emailAsKey, permission: permission }];
            }
        });
    });
});
export var changeUserPermission = createAsyncThunk('workspace/user/changePermission', function (_a, _b) {
    var userId = _a.userId, newPermission = _a.newPermission;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    workspaceId = getState().workspace.id;
                    mixpanel.track('change user permission', { newPermission: newPermission });
                    return [4 /*yield*/, _changeUserPermission(userId, newPermission, workspaceId).then(function () {
                            return { userId: userId, newPermission: newPermission };
                        })];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
});
var _changeUserPermission = function (userId, newPermission, workspaceId) {
    return new Promise(function (resolve, reject) {
        var updates = {};
        updates["workspaces/".concat(workspaceId, "/users/").concat(userId, "/permission")] =
            newPermission;
        update(ref(database), updates)
            .then(resolve)
            .catch(function (err) {
            console.log(err);
            reject();
        });
    });
};
export var removeUserFromWorkspace = createAsyncThunk('workspace/user/remove', function (_a, _b) {
    var userId = _a.userId;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspace;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    workspace = getState().workspace;
                    mixpanel.track('remove user from workspace');
                    return [4 /*yield*/, _removeUserFromWorkspace(workspace.id, userId)];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
});
export var _removeUserFromWorkspace = function (workspaceId, userId) {
    return new Promise(function (resolve, reject) {
        var updates = {};
        updates["workspaces/".concat(workspaceId, "/users/").concat(userId)] = null;
        update(ref(database), updates)
            .then(function () {
            resolve(userId);
        })
            .catch(function (err) {
            console.log(err);
            reject();
        });
    });
};
export var getWorkspaceName = createAsyncThunk('invite/getWorkspaceName', function (workspaceId) { return __awaiter(void 0, void 0, void 0, function () {
    var name;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, _getWorkspaceName(workspaceId)];
            case 1:
                name = _b.sent();
                return [2 /*return*/, (_a = {},
                        _a[workspaceId] = {
                            workspaceName: name,
                        },
                        _a)];
        }
    });
}); });
export var _getWorkspaceName = function (workspaceId) {
    return new Promise(function (resolve, reject) {
        get(ref(database, "workspaces/".concat(workspaceId, "/name")))
            .then(function (snapshot) {
            var name = snapshot.val();
            resolve(name);
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
export var renameWorkspace = createAsyncThunk('workspace/rename', function (name, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    workspaceId = getState().workspace.id;
                    mixpanel.track('rename workspace');
                    return [4 /*yield*/, _renameWorkspace(name, workspaceId)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
});
var _renameWorkspace = function (name, workspaceId) {
    return new Promise(function (resolve, reject) {
        update(ref(database, "workspaces/".concat(workspaceId)), { name: name })
            .then(function () { return resolve(name); })
            .catch(function (error) { return reject(error); });
    });
};
export var _updateBillingNotificationEmail = function (newEmail, workspaceId) {
    return new Promise(function (resolve, reject) {
        update(ref(database, "subscriptions/".concat(workspaceId)), {
            emailNotification: newEmail,
        })
            .then(resolve)
            .catch(function (error) { return reject(error); });
    });
};
var _inviteUserToWorkspace = function (_a) {
    var email = _a.email, workspaceId = _a.workspaceId, permission = _a.permission, authToken = _a.authToken;
    return axios
        .post('/api/workspace/invite-user', {
        authToken: authToken,
        workspaceId: workspaceId,
        email: email,
        permission: permission,
    })
        .catch(function (err) {
        console.log(err);
        displayToast('error', 'Something went wrong');
    });
};
// const deleteWorkspace = createAsyncThunk(
// 	'workspace/delete',
// 	async (_, { getState }) => {
// 		const workspaceId = (getState() as RootState).workspace
// 	}
// )
// const _deleteWorkspace = (workspaceId: string) => {
// 	return new Promise((resolve, reject) => {
//
/*

1. remove workspace reference from each user in the workspace
2. remove auth token claims for each user
3. delete all the images in Storage
4. delete all the Collections in the Database
5. Lastly, delete the Workspace in Database

*/
// 	})
// }
// ----------------------------------------------
// Firebase controllers
// ----------------------------------------------
// const _removeWorkspace = ({
// 	workspaceId,
// 	owner,
// }: {
// 	workspaceId: string
// 	owner: User
// }) => {
// 	let updates: any = {}
// 	updates[`workspaces/${workspaceId}`] = null
// 	updates[`users/${owner.id}/workspaces`] = owner.workspaces?.filter(
// 		(_id) => _id !== workspaceId
// 	)
// 	return update(ref(database), updates)
// }
var _createWorkspace = function (name, user
// plan: Workspace['_admin']['plan'] = 'free'
) {
    return new Promise(function (resolve, reject) {
        return axios
            .post('/api/workspace/create', {
            userId: user.id,
            workspaceName: name || 'My Workspace',
        })
            .then(function (response) {
            var workspace = response.data.payload;
            _refreshUserToken();
            resolve(workspace);
        })
            .catch(function (err) {
            console.log(err);
            displayToast('error', 'Something went wrong');
            reject();
        });
    });
};
export var upgradeWorkspace = createAsyncThunk('workspace/upgrade', function (_, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    workspaceId = getState().workspace.id;
                    return [4 /*yield*/, _upgradeWorkspace(workspaceId)];
                case 1: 
                // mixpanel.track('upgrade workspace')
                return [2 /*return*/, _b.sent()];
            }
        });
    });
});
var _upgradeWorkspace = function (workspaceId) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (axios
                    // .post('/api/workspace/upgrade-plan', {
                    .post('/api/subscription/generate-payment-link', {
                    workspaceId: workspaceId,
                })
                    .then(function (response) {
                    console.log(response.data.payload);
                    _refreshUserToken();
                    resolve();
                })
                    .catch(function (err) {
                    console.log(err);
                    displayToast('error', 'Something went wrong');
                    reject();
                }))];
        });
    }); });
};
export var downgradeWorkspace = createAsyncThunk('workspace/downgrade', function (_, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    workspaceId = getState().workspace.id;
                    return [4 /*yield*/, _downgradeWorkspace(workspaceId)];
                case 1: 
                // mixpanel.track('downgrade workspace')
                return [2 /*return*/, _b.sent()];
            }
        });
    });
});
var _downgradeWorkspace = function (workspaceId) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios
                    .post('/api/workspace/downgrade-plan', {
                    workspaceId: workspaceId,
                })
                    .then(function () {
                    _refreshUserToken();
                    resolve();
                })
                    .catch(function (err) {
                    console.log(err);
                    displayToast('error', 'Something went wrong');
                    reject();
                })];
        });
    }); });
};
